import _isEmpty from 'lodash/isEmpty';

import {
  WeddingDateFormFields,
  RankedDateField,
} from '~/components/common/form/WeddingDateField/types';

import {
  WeddingDateFieldError,
  validateWeddingDateField,
} from '../WeddingDateField/validateWeddingDateField';

/**
 * Custom form validator for flexible wedding dates.
 */
const validateFlexibleWeddingDates = (values: WeddingDateFormFields) => {
  const { expandedWeddingYears, expandedWeddingMonths, expandedWeddingWeekdays } = values;

  // ensure every year that is selected has at least one month selected
  if (
    expandedWeddingYears &&
    expandedWeddingYears.length > 0 &&
    expandedWeddingMonths &&
    !_isEmpty(expandedWeddingMonths)
  ) {
    const yearsWithMonthSelections = Object.keys(expandedWeddingMonths).filter(
      (month) => expandedWeddingMonths[month].length !== 0
    );

    const firstYearWithNoMonthsSelection = expandedWeddingYears.find(
      (year) => !yearsWithMonthSelections.includes(year)
    );

    if (firstYearWithNoMonthsSelection) {
      return {
        expandedWeddingMonths: {
          [firstYearWithNoMonthsSelection]: 'Please select at least one month',
        },
      };
    }
  }

  if (_isEmpty(expandedWeddingWeekdays)) {
    return {
      expandedWeddingWeekdays: 'Please select at least one day of the week',
    };
  }
  return undefined;
};

type ValidateRankedDateSelectionResult = {
  [field in RankedDateField]: WeddingDateFieldError;
};
/**
 * Adapter to build a FormValidator for a ranked date field.
 */
const validateRankedDateSelection =
  (field: RankedDateField) =>
  (values: WeddingDateFormFields): ValidateRankedDateSelectionResult => {
    return validateWeddingDateField(values, field);
  };

/**
 * Form validator for the venue date question.  It either validates the flexible
 * wedding dates, or the ranked date selections.  Ranked date validation returns
 * objects (not strings).  I couldn't use combined validators because combine
 * validators stops validating when it finds a truthy value.
 */
export const validateExpandedWeddingDates = (values: WeddingDateFormFields) => {
  if (values.showFlexibleDateSelection) {
    return validateFlexibleWeddingDates(values);
  }

  return {
    ...validateRankedDateSelection('expandedWeddingDateFirstChoice')(values),
    ...validateRankedDateSelection('expandedWeddingDateSecondChoice')(values),
    ...validateRankedDateSelection('expandedWeddingDateThirdChoice')(values),
  };
};
